export enum PictogramType {
    BOX = "box",
    LABELED_ICON = "labeled_icon"
}
export enum PictogramType {
    BOX = "box",
    LABELED_ICON = "labeled_icon"
}
